// components/admin/ConfirmDeleteModal.tsx
import React from 'react';
import { User } from '../../types/user';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    user: User | null;
}

export default function ConfirmDeleteModal({ isOpen, onClose, onConfirm, user }: Props) {
    if (!isOpen || !user) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="bg-white text-black p-6 rounded shadow-lg w-full max-w-sm">
                <h2 className="text-xl font-bold mb-4">Benutzer löschen</h2>
                <p>
                    Möchtest du den Benutzer&nbsp;
                    <strong>{user.firstName} {user.lastName}</strong> mit der E-Mail&nbsp;
                    <strong>{user.email}</strong> wirklich löschen?
                </p>
                <div className="mt-6 flex justify-end gap-3">
                    <button onClick={onClose} className="px-4 py-2 border">Abbrechen</button>
                    <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white">Löschen</button>
                </div>
            </div>
        </div>
    );
}
